import BaseModelAPI from '../BaseModelAPI';

export default class JigList extends BaseModelAPI {

	static entity = 'jiglist'
	static entityName = 'jig';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
